var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-13',[_c('div',{staticClass:"item",style:({ height: _vm.col + 'vh' })},[_c('div',{staticClass:"font-weight font-s"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"PLMTTRechart"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-880666ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/andon/component/production-mttr.vue
// module id = null
// module chunks = 